// extracted by mini-css-extract-plugin
export var productsCarousel = "styles-module--productsCarousel--a35hA";
export var One = "styles-module--One--xf8qp";
export var Four = "styles-module--Four--ckB2d";
export var cardItem = "styles-module--cardItem--2npuI";